<template>
    <div class="tab-view">

        <fb-tab-nav v-if="showNavTab" :tab-items="views" :current-item="currentView" @handleChangeTab="handleChangeTab"
                    @handelCloseTab="handelCloseTab" @handleCloseOthers="handleCloseOthers"
                    @handleCloseAll="handleCloseAll"></fb-tab-nav>


        <div v-if="!showNavTab" class="nav-tab" style="padding: 20px;background-color: #f5f7f9;">
            <el-page-header @back="$router.back()" :content="$route.meta.title"></el-page-header>
        </div>

        <fb-scrollbar ref="scrollbar" :padding="`${showNavTab ? '20px':'0'} 20px 20px 20px`" class="tv-main-body">
            <template v-for="view in views">
                <component v-show="view === currentView" v-bind:is="view.component" :params="view.params"
                           :query="view.query"
                           :timestamp="view.timestamp"
                           v-bind:key="view.id"></component>
            </template>
        </fb-scrollbar>
    </div>
</template>

<script>

    export default {
        name: "TabView",
        props: {
            showNavTab: {
                type: Boolean,
                default: function () {
                    return true;
                }
            }
        },
        components: {},
        data() {
            return {
                views: [],
                currentView: null,
                route: true
            }
        },
        watch: {
            '$route': function () {

                this.$refs.scrollbar.resetScrollbar();

                this.$emit('handleTabChange');

                if (window.routeType === 'back') {
                    window.routeType = '';
                    if(this.currentView.lastView){
                        this.handelCloseTab(this.currentView);
                        this.handleChangeTab(this.currentView.lastView);
                    }


                    return;
                }
                if (this.route && window.route) {
                    this.addView();
                } else {
                    this.route = true;
                    window.route = true;
                }



            }
        },
        methods: {

            handleCloseOthers(item) {
                this.views = [item];
                this.handleChangeTab(item);

            },

            handleCloseAll() {
                let vm = this;
                let view = this.views.find((v) => {
                    return v.path === '/home'
                });

                if (view) {
                    this.handleCloseOthers(view);
                } else {
                    this.views = [];
                    vm.$router.push('/home');
                }


            },

            handleChangeTab(item) {
                let vm = this;
                vm.route = false;
                vm.currentView.query = this.$route.query;
                vm.$router.push(item);
                vm.currentView = item;
                item.timestamp = new Date().getTime();
                vm.$nextTick(()=>{
                    vm.route = true;
                });
            },
            handelCloseTab(item) {
                this.views.splice(this.views.indexOf(item), 1);
            },
            addView() {

                if (!this.$route.meta.tab) {
                    return;
                }

                let view = {
                    lastView: this.currentView,
                    title: this.$route.meta.title,
                    path: this.$route.path,
                    params: this.$route.params,
                    query: this.$route.query,
                    timestamp: new Date().getTime(),
                    component: this.$route.matched[this.$route.matched.length - 1].components.default,
                    id: new Date().getTime()
                };
                this.currentView = view;
                this.views.push(view);
            },
        },
        created() {

            let vm = this;

            vm.addView();

            vm.$router.updateQuery = function () {
                // window.route = false;
                // vm.$router.push(arguments[0]);
                // vm.$nextTick(()=>{
                //     window.route = true;
                // });
            };

            vm.$router.cgBack = function () {
                window.routeType = 'back';
                vm.$router.back();
            };




            window.route =true;

        }
    }
</script>

<style lang="scss" scoped>


    .tab-view {
        height: 100%;
        position: relative;
        width: 100%
    }

    .tv-main-body {
        background-color: #f5f7f9;
        overflow: hidden;
        height: 100%;
        /*padding: 20px;*/
    }


</style>
